// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3MGKJ","header":"ClearentDisclaimer_header__35i54","inner":"ClearentDisclaimer_inner__2yGjt"};